export const USER_ADMIN_REQUEST = "userAdminReducer/USER_ADMIN_REQUEST";
export const USER_ADMIN_SUCCESS = "userAdminReducer/USER_ADMIN_SUCCESS";
export const USER_ADMIN_FAILED = "userAdminReducer/USER_ADMIN_FAILED";
export const CHANGE_DIALOG_ADMIN_STATUS =
  "userAdminReducer/CHANGE_DIALOG_ADMIN_STATUS";
export const USER_ADMIN_EDIT = "userAdminReducer/USER_ADMIN_EDIT";
